import { css } from '@emotion/react';
import { MediaBreakpointUp, breakpointInfix } from './mixins/_breakpoints.mixin';
import { MakeContainer, MakeRow } from './mixins/_grid.css';
import { MakeGridColumns } from './mixins/_grid-framework.css';


export default ($) => {
  if (!$.enableGridClasses) {
    return css``;
  }

  return css(Object.values(styles)
    .map((style) => style($))
    .filter(x => !!x)
  );
}

const styles = {};

// Container widths
//
// Set the container width, and override it for fixed navbars in media queries.
styles.containerWidths = ($) => {
  const rules = [];

  if ($.enableGridClasses) {
    const containerFluidStyles = new MakeContainer().include($);
    rules.push(css`
      // Single container class with breakpoint max-widths
      .container,
      // 100% wide container at all breakpoints
      .container-fluid {
        ${containerFluidStyles};
      }
    `)

    // Responsive containers that are 100% wide until a breakpoint
    Object.entries($.containerMaxWidths).forEach(([breakpoint, containerMaxWidth]) => {
      rules.push(css(makeResponsiveContainer(
        $,
        breakpoint,
        containerMaxWidth,
        containerFluidStyles,
      )));
    });
  }

  return css(rules);
};


function makeResponsiveContainer(
  $,
  breakpoint,
  containerMaxWidth,
  containerFluidStyles,
) {
  $ = Object.create($);

  // Extend each breakpoint which is smaller or equal to the current breakpoint
  const breakpointRules = [];
  let extendBreakpoint = true;

  Object.keys($.gridBreakpoints).forEach((name) => {
    if (extendBreakpoint) {
      const infix = breakpointInfix($, name, $.gridBreakpoints);
      breakpointRules.push(css`
        .container${infix} {
          max-width: ${containerMaxWidth};
        }
      `);

      if (breakpoint === name) {
        extendBreakpoint = false;
      }
    }
  })


  return css`
    .container-${breakpoint} {
      ${containerFluidStyles};
    }

    ${new MediaBreakpointUp(
      breakpoint, $.gridBreakpoints
    ).include($, css(breakpointRules))}
  `;
}


// Row
//
// Rows contain your columns.
styles.rows = $ => {
  if (!$.enableGridClasses) {
    return css``;
  }

  return css`
    .row {
      ${new MakeRow().include($)}
    }

      // Remove the negative margin from default .row, then the horizontal padding
      // from all immediate children columns (to prevent runaway style inheritance).
      .no-gutters {
        margin-right: 0;
        margin-left: 0;

        > .col,
        > [class*="col-"] {
          padding-right: 0;
          padding-left: 0;
        }
      }
  `;
}



// Columns
//
// Common styles for small and large grid columns
styles.columns = $ => {
  if (!$.enableGridClasses) {
    return css``;
  }

  return new MakeGridColumns().include($);
};